// extracted by mini-css-extract-plugin
module.exports = {"link":"PointHistoryTable_link__iMTuB","pointPlus":"PointHistoryTable_pointPlus__0n1Pl","pointMinus":"PointHistoryTable_pointMinus__K0Qms"};